




import { Component, Vue, Prop } from "vue-property-decorator";
import SelectOption from "../../common/ui/presenters/select-option";
import ProjectCompany from "@/models/project-company";

@Component({})
export default class SelectCompany extends Vue {
  @Prop({ required: true }) value!: string;
  @Prop({ default: () => [] }) items!: ProjectCompany[];

  get options(): SelectOption[] {
    const options = this.items.map(c => ({
      text: c.name,
      value: String(c.id)
    }));
    return [...this.defaultOptions, ...options];
  }

  input(value: string) {
    return this.$emit("input", value);
  }

  private defaultOptions: SelectOption[] = [
    {
      text: "全ての会社",
      value: ""
    }
  ];
}
